const doc = [({"en":({"js":({"admin":({"activity_surveys":({"table":({"replies":"Replies"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;